import { render, staticRenderFns } from "./icon-user.vue?vue&type=template&id=c8e5fa7a&scoped=true&"
import script from "./icon-user.vue?vue&type=script&lang=js&"
export * from "./icon-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e5fa7a",
  null
  
)

export default component.exports